// Web-vitals tracking → Яндекс.Метрика goals.
// Измеряем реальные пользовательские метрики Core Web Vitals 2026:
// - LCP (Largest Contentful Paint): порог "good" ≤ 2.5s
// - INP (Interaction to Next Paint): ≤ 200ms (заменил FID с 2024)
// - CLS (Cumulative Layout Shift): < 0.1
// - FCP (First Contentful Paint): для дебага
// - TTFB (Time To First Byte): сервер-сайд
//
// Данные летят в Метрику как параметры визитов (CWV_*).
// В Метрике можно настроить отчёты «Параметры визитов» → CWV_LCP/INP/CLS.
// Лимит web-vitals API — отправляет каждое значение ОДИН раз за сессию (на unload).

import { onLCP, onINP, onCLS, onFCP, onTTFB } from "web-vitals";

// Yandex Metrika counter ID — должен совпадать с тем, что в public/index.html
const YM_COUNTER_ID = 98550756;

// Округление чтобы не плодить уникальные значения параметров.
const formatValue = (name, value) => {
  if (value === null || value === undefined) return null;
  // CLS — это безразмерное число < 1; остальные в миллисекундах.
  if (name === "CLS") return Math.round(value * 1000) / 1000;
  return Math.round(value);
};

const sendToYandex = ({ name, value, rating }) => {
  const ymFn = typeof window !== "undefined" ? window.ym : null;
  if (!ymFn || typeof ymFn !== "function") return;
  const v = formatValue(name, value);
  if (v === null) return;
  // Параметры визита (видны в отчёте "Параметры визитов")
  try {
    ymFn(YM_COUNTER_ID, "params", {
      [`CWV_${name}`]: v,
      [`CWV_${name}_rating`]: rating, // good | needs-improvement | poor
    });
    // Цель — для построения сегментов "пользователи с плохим LCP"
    ymFn(YM_COUNTER_ID, "reachGoal", `cwv_${name.toLowerCase()}_${rating}`);
  } catch (e) {
    // Метрика может не быть готова на ранних рендерах — пропускаем без шума.
  }
};

export const reportWebVitals = () => {
  // Все хендлеры идемпотентны: web-vitals дедуплицирует значения сам.
  onLCP(sendToYandex);
  onINP(sendToYandex);
  onCLS(sendToYandex);
  onFCP(sendToYandex);
  onTTFB(sendToYandex);
};
